import { getCookieValue, cookieNames } from "utility/CookieHelper";

export const getIsCardVendorNium = () => {
  return getCookieValue(cookieNames.USER_CARD_VENDOR) === "NIUM";
};

export const getIsCardMatchMove = () => {
  return getCookieValue(cookieNames.USER_CARD_VENDOR) === "MatchMove";
};
